var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInstagramColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t {fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000101104666855591476730000002557372802201059717_);}\r\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 3.1386,
    cy: -0.1139,
    r: 31.3312,
    gradientTransform: "matrix(1 0 0 -1 0 24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#FA8F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#D82D7E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,12c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S8,14.2,8,12 M5.8,12c0,3.4,2.8,6.2,6.2,6.2s6.2-2.8,6.2-6.2 S15.4,5.8,12,5.8S5.8,8.6,5.8,12 M16.9,5.6c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4h0 C17.6,4.2,16.9,4.8,16.9,5.6 M7.1,21.8c-1.2-0.1-1.8-0.2-2.2-0.4c-0.6-0.2-1-0.5-1.4-0.9c-0.4-0.4-0.7-0.8-0.9-1.4 c-0.2-0.4-0.4-1.1-0.4-2.2c-0.1-1.3-0.1-1.6-0.1-4.8s0-3.6,0.1-4.8C2.2,6,2.4,5.3,2.6,4.9c0.2-0.6,0.5-1,0.9-1.4s0.8-0.7,1.4-0.9 c0.4-0.2,1.1-0.4,2.2-0.4C8.4,2.2,8.7,2.2,12,2.2s3.6,0,4.8,0.1C18,2.3,18.6,2.5,19,2.6c0.6,0.2,1,0.5,1.4,0.9s0.7,0.8,0.9,1.4 c0.2,0.4,0.4,1.1,0.4,2.2c0.1,1.3,0.1,1.6,0.1,4.8s0,3.6-0.1,4.8c-0.1,1.2-0.2,1.8-0.4,2.2c-0.2,0.6-0.5,1-0.9,1.4 c-0.4,0.4-0.8,0.7-1.4,0.9c-0.4,0.2-1.1,0.4-2.2,0.4c-1.3,0.1-1.6,0.1-4.8,0.1S8.4,21.8,7.1,21.8 M7,0.1C5.7,0.1,4.9,0.3,4.1,0.6 C3.3,0.9,2.6,1.3,2,2S0.9,3.4,0.6,4.1C0.3,4.9,0.1,5.8,0,7.1C0,8.3-0.1,8.7-0.1,12s0,3.7,0.1,4.9c0.1,1.3,0.3,2.2,0.6,2.9 C0.9,20.6,1.3,21.3,2,22s1.3,1.1,2.1,1.4c0.8,0.3,1.6,0.5,2.9,0.6C8.3,24,8.7,24,12,24s3.7,0,4.9-0.1c1.3-0.1,2.2-0.3,2.9-0.6 c0.8-0.3,1.5-0.7,2.1-1.4s1.1-1.3,1.4-2.1c0.3-0.8,0.5-1.6,0.6-2.9c0.1-1.3,0.1-1.7,0.1-4.9s0-3.7-0.1-4.9c-0.1-1.3-0.3-2.2-0.6-2.9 C23,3.4,22.6,2.7,21.9,2s-1.3-1.1-2.1-1.4c-0.8-0.3-1.6-0.5-2.9-0.6C15.6,0,15.2,0,12,0S8.3,0,7,0.1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000028309053599221906150000014712573970987949210_",
    cx: 14.5055,
    cy: -1.1891,
    r: 24.6933,
    gradientTransform: "matrix(1 0 0 -1 0 24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#8C3AAA",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C3AAA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028309053599221906150000014712573970987949210_)"
    },
    d: "M8,12c0-2.2,1.8-4,4-4s4,1.8,4,4 s-1.8,4-4,4S8,14.2,8,12 M5.8,12c0,3.4,2.8,6.2,6.2,6.2s6.2-2.8,6.2-6.2S15.4,5.8,12,5.8S5.8,8.6,5.8,12 M16.9,5.6 c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4h0C17.6,4.2,16.9,4.8,16.9,5.6 M7.1,21.8c-1.2-0.1-1.8-0.2-2.2-0.4 c-0.6-0.2-1-0.5-1.4-0.9c-0.4-0.4-0.7-0.8-0.9-1.4c-0.2-0.4-0.4-1.1-0.4-2.2c-0.1-1.3-0.1-1.6-0.1-4.8s0-3.6,0.1-4.8 C2.2,6,2.4,5.3,2.6,4.9c0.2-0.6,0.5-1,0.9-1.4s0.8-0.7,1.4-0.9c0.4-0.2,1.1-0.4,2.2-0.4C8.4,2.2,8.7,2.2,12,2.2s3.6,0,4.8,0.1 C18,2.3,18.6,2.5,19,2.6c0.6,0.2,1,0.5,1.4,0.9s0.7,0.8,0.9,1.4c0.2,0.4,0.4,1.1,0.4,2.2c0.1,1.3,0.1,1.6,0.1,4.8s0,3.6-0.1,4.8 c-0.1,1.2-0.2,1.8-0.4,2.2c-0.2,0.6-0.5,1-0.9,1.4c-0.4,0.4-0.8,0.7-1.4,0.9c-0.4,0.2-1.1,0.4-2.2,0.4c-1.3,0.1-1.6,0.1-4.8,0.1 S8.4,21.8,7.1,21.8 M7,0.1C5.7,0.1,4.9,0.3,4.1,0.6C3.3,0.9,2.6,1.3,2,2S0.9,3.4,0.6,4.1C0.3,4.9,0.1,5.8,0,7.1 C0,8.3-0.1,8.7-0.1,12s0,3.7,0.1,4.9c0.1,1.3,0.3,2.2,0.6,2.9C0.9,20.6,1.3,21.3,2,22s1.3,1.1,2.1,1.4c0.8,0.3,1.6,0.5,2.9,0.6 C8.3,24,8.7,24,12,24s3.7,0,4.9-0.1c1.3-0.1,2.2-0.3,2.9-0.6c0.8-0.3,1.5-0.7,2.1-1.4s1.1-1.3,1.4-2.1c0.3-0.8,0.5-1.6,0.6-2.9 c0.1-1.3,0.1-1.7,0.1-4.9s0-3.7-0.1-4.9c-0.1-1.3-0.3-2.2-0.6-2.9C23,3.4,22.6,2.7,21.9,2s-1.3-1.1-2.1-1.4 c-0.8-0.3-1.6-0.5-2.9-0.6C15.6,0,15.2,0,12,0S8.3,0,7,0.1"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagramColor);
export default __webpack_public_path__ + "static/media/icon-instagram-color.d3a5bcf2c629acd1be3b8b205caa1e6e.svg";
export { ForwardRef as ReactComponent };